import { Text } from "rebass";
import styled from "styled-components";

export const RecordText = styled(Text)`
  padding: 0;
  font-size: inherit;
  line-height: 1.56;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;

RecordText.defaultProps = {
  as: "p",
  fontFamily: "Georgia",
  lineHeight: [1.56],
  color: "transparent",
  bg: "transparent",
};
